<template>
    <van-popup v-model:show="show" position="bottom" :overlay-style="{ overflow: 'hidden' }" :style="{
        minWidth: '100%',
        minHeight: '100%',
        color: '#fff',
    }">
        <div class="popupContainer">
            <CustomHeader :text="$t('common.sake')" :isPopupCloseBackIcon="true" @closePopup="close" />
            <div class="InfoList">
                <div class="topAmount">
                    <span class="inputLabel">{{ $t('withdraw.valueText') }}</span>
                    <van-row class="amountRow">
                        <van-col span="2" class="left_icon">R$</van-col>
                        <van-col span="22" class="amount">{{ $t("withdraw.value") }} {{
                            formatCurrency(dataSet?.selectedAmount) }}</van-col>
                    </van-row>
                </div>

                <div class="inputLabel">{{ $t('withdraw.taxIdType') }}</div>
                <div class="tabList">
                    <div class="tab_card" v-for="item in TAB_TYPE_LIST" :key="item.id"
                        :class="dataSet?.activeTab.id == item.id ? 'active_tab' : ''" @click="selectTabType(item)">
                        {{ item.name }}
                    </div>
                </div>

                <div class="input_field" v-if="dataSet?.activeTab.id == 1">
                    <div class="inputLabel">CPF ID</div>
                    <van-field v-model="cpfID" type="number"
                        :disabled="dataSet?.isDisabled && withdrawStore.withdrawInfo.cpf != null && withdrawStore.withdrawInfo.cpf != ''"
                        :placeholder="$t('withdraw.cpfIdPlaceholder')">
                        <template #right-icon>
                            <van-icon name="credit-pay" />
                        </template>
                    </van-field>
                </div>
                <div class="input_field" v-if="dataSet?.activeTab.id == 2">
                    <div class="inputLabel">Email ID</div>
                    <van-field v-model="emailID"
                        :disabled="dataSet?.isDisabled && withdrawStore.withdrawInfo.email != null && withdrawStore.withdrawInfo.email != ''"
                        :placeholder="$t('withdraw.emailPlaceholder')">
                        <template #right-icon>                            
                            <van-icon name="credit-pay" />
                        </template>
                    </van-field>
                </div>
                <div class="input_field" v-if="dataSet?.activeTab.id == 3">
                    <div class="inputLabel">PHONE ID</div>
                    <van-field v-model="phoneID" type="number"
                        :disabled="dataSet?.isDisabled && withdrawStore.withdrawInfo.phone != null && withdrawStore.withdrawInfo.phone != ''"
                        :placeholder="$t('withdraw.phonePlaceholder')">
                        <template #right-icon>
                            <van-icon name="credit-pay" />
                        </template>
                    </van-field>
                </div>
                <div class="input_field" v-if="dataSet?.activeTab.id == 4">
                    <div class="inputLabel">EVP</div>
                    <van-field v-model="evpID"
                        :disabled="dataSet?.isDisabled && withdrawStore.withdrawInfo.evpId != null && withdrawStore.withdrawInfo.evpId != ''"
                        :placeholder="$t('withdraw.evpPlaceholder')">
                        <template #right-icon>
                            <van-icon name="credit-pay" />
                        </template>
                    </van-field>
                </div>
                <div class="errorText" v-if="dataSet?.activeTab.id == 1 && showCPFIdError
                    || dataSet?.activeTab.id == 2 && showEmaiIdError
                    || dataSet?.activeTab.id == 3 && showPhoneIdError
                    || dataSet?.activeTab.id == 4 && showEvpIdError">
                    {{
                        t(dataSet?.activeTab.errorText) }}</div>

                <div class="input_field">
                    <div class="inputLabel">{{ $t('withdraw.userName') }}</div>
                    <van-field v-model="userName"
                        :disabled="dataSet?.isDisabled && withdrawStore.withdrawInfo.userName != null && withdrawStore.withdrawInfo.userName != ''"
                        :placeholder="$t('withdraw.userNamePlaceholder')">
                        <template #right-icon>
                            <van-icon name="contact" />
                        </template>
                    </van-field>
                </div>

                <div class="input_field">
                    <div class="inputLabel">CPF</div>
                    <van-field v-model="cpfNumber" type="number"
                        :disabled="dataSet?.isDisabled && withdrawStore.withdrawInfo.cpfId != null && withdrawStore.withdrawInfo.cpfId != ''"
                        :placeholder="$t('withdraw.userNamePlaceholder')">
                        <template #right-icon>
                            <van-icon name="credit-pay" />
                        </template>
                    </van-field>
                </div>
                <div v-if="showCPFNumError" class="errorText">{{ $t("withdraw.cpfErrorText") }}</div>

                <div class="input_field" v-if="dataSet?.selectedChannel.channelType == '7'">
                    <div class="inputLabel">{{ $t("withdraw.brazilId") }}</div>
                    <van-field v-model="brazilID"
                        :disabled="dataSet?.isDisabled && withdrawStore.withdrawInfo.brazilId != null && withdrawStore.withdrawInfo.brazilId != ''"
                        type="number" :placeholder="$t('withdraw.brazilIdPlaceholder')">
                        <template #right-icon>
                            <van-icon name="contact" />
                        </template>
                    </van-field>
                </div>
                <div class="input_field" v-if="dataSet?.selectedChannel.channelType == '1'">
                    <div class="inputLabel">{{ $t("withdraw.bank") }}</div>
                    <van-field v-model="bank"
                        :disabled="dataSet?.isDisabled && withdrawStore.withdrawInfo.bank != null && withdrawStore.withdrawInfo.bank != ''"
                        type="text" :placeholder="$t('withdraw.bankPlaceholder')">
                        <template #right-icon>
                            <van-icon name="shop-o" />
                        </template>
                    </van-field>
                </div>
            </div>
            <div class="btn_container">
                <MainButton :title="$t('common.sake')" :activeStatus="activeButton" @click="confirmWithdraw" />
            </div>

        </div>

    </van-popup>
</template>

<script setup lang="ts">
import { ref, defineExpose, defineEmits, watch, defineProps, computed } from 'vue'
import CustomHeader from '../components/common/customHeader.vue';
import { useI18n } from 'vue-i18n';
import MainButton from '../components/common/mainButton.vue';
import { formatCurrency } from '@/utils/commonFunction';
import { TAB_TYPE_LIST, WithdrawPopupData } from '@/view/withdraw/supportScript';
import { useWithdrawStore } from '@/stores/withdraw';
const { t } = useI18n();
const withdrawStore = useWithdrawStore()

const props = defineProps<{
    dataSet: WithdrawPopupData
}>()

const show = ref(props.dataSet.show)
const cpfID = ref(props.dataSet.cpfID)
const emailID = ref(props.dataSet.emailID)
const phoneID = ref(props.dataSet.phoneID)
const evpID = ref(props.dataSet.evpID)
const userName = ref(props.dataSet.userName)
const cpfNumber = ref(props.dataSet.cpfNumber)
const brazilID = ref(props.dataSet.brazilID)
const bank = ref(props.dataSet.bank)
const showCPFIdError = ref(props.dataSet.showCPFIdError)
const showEmaiIdError = ref(props.dataSet.showEmaiIdError)
const showPhoneIdError = ref(props.dataSet.showPhoneIdError)
const showEvpIdError = ref(props.dataSet.showEvpIdError)
const showCPFNumError = ref(props.dataSet.showCPFNumError)
const activeButton = ref(false)

const emits = defineEmits(['close', 'open', 'selectTabType', 'confirmWithdraw', 'checkFieldsFill', 'update:dataSet', 'changeValue'])

const open = (amount: number, data: any) => {
    emits('open')
}
const close = () => {
    emits('close')
}

const selectTabType = (item: any) => {
    emits('selectTabType', item)
}

const confirmWithdraw = () => {
    emits('confirmWithdraw')
}

// const checkFieldsFill = () => {
//     emits('checkFieldsFill')
// }
watch(() => props.dataSet, (newVal) => {
    cpfID.value = newVal.cpfID
    emailID.value = newVal.emailID
    phoneID.value = newVal.phoneID
    evpID.value = newVal.evpID
    userName.value = newVal.userName
    cpfNumber.value = newVal.cpfNumber
    brazilID.value = newVal.brazilID
    bank.value = newVal.bank
}, { deep: true, immediate: true })

watch(cpfID, (val) => {
    if (val.length == 11) {
        showCPFIdError.value = false
    } else {
        showCPFIdError.value = true
    }
    let data = {
        type: 'cpfID',
        value: val
    }
    emits('changeValue', data)
    checkFieldsFill()
})
watch(emailID, (val) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (emailRegex.test(val)) {
        showEmaiIdError.value = false
    } else {
        showEmaiIdError.value = true
    }
    let data = {
        type: 'emailID',
        value: val
    }
    emits('changeValue', data)
    checkFieldsFill()
})
watch(phoneID, (val) => {
    if (val.length == 11) {
        showPhoneIdError.value = false
    } else {
        showPhoneIdError.value = true
    }
    let data = {
        type: 'phoneID',
        value: val
    }
    emits('changeValue', data)
    checkFieldsFill()
})
watch(evpID, (val) => {
    if (val.length > 0) {
        showEvpIdError.value = false
    } else {
        showEvpIdError.value = true
    }
    let data = {
        type: 'evpID',
        value: val
    }
    emits('changeValue', data)
    checkFieldsFill()
})
watch(cpfNumber, (val) => {
    const value = String(val ?? '')

    if (value.length > 0 && value.length !== 11) {
        showCPFNumError.value = true
    } else {
        showCPFNumError.value = false
    }
    const data = {
        type: 'cpfNumber',
        value: val
    }
    emits('changeValue', data)
    checkFieldsFill()
})

watch(userName, (val) => {
    let data = {
        type: 'userName',
        value: val
    }
    emits('changeValue', data)
    checkFieldsFill()
})
watch(brazilID, (val) => {
    let data = {
        type: 'brazilID',
        value: val
    }
    emits('changeValue', data)
    checkFieldsFill()
})
watch(bank, (val) => {
    let data = {
        type: 'bank',
        value: val
    }
    emits('changeValue', data)
    checkFieldsFill()
})
const checkFieldsFill = () => {
    const activeId = props.dataSet.activeTab?.id

    if (activeId === 1) {
        activeButton.value = (cpfID.value !== '') &&
            (userName.value !== '') &&
            (cpfNumber.value !== '') &&
            !showCPFIdError.value &&
            !showCPFNumError.value
    } else if (activeId === 2) {
        activeButton.value = (emailID.value !== '') &&
            (userName.value !== '') &&
            (cpfNumber.value !== '') &&
            !showEmaiIdError.value &&
            !showCPFNumError.value
    } else if (activeId === 3) {
        activeButton.value = (phoneID.value !== '') &&
            (userName.value !== '') &&
            (cpfNumber.value !== '') &&
            !showPhoneIdError.value &&
            !showCPFNumError.value
    } else if (activeId === 4) {
        activeButton.value = (evpID.value !== '') &&
            (userName.value !== '') &&
            (cpfNumber.value !== '') &&
            !showEvpIdError.value &&
            !showCPFNumError.value
    }
}

defineExpose({
    open,
    close
})

</script>
<style scoped>
.popupContainer {
    background: url('@/assets/main_bg.png');
    background-size: cover;
    background-repeat: repeat;
    width: 100%;
    min-height: 90vh;
    padding: 50px 0;
    overflow-y: auto;
}

/* .scrollable-content {
    flex: 1;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
} */

.InfoList {
    padding: 10px 25px;
}

.van-popup::-webkit-scrollbar {
    display: none;
}

.topAmount {
    border-bottom: solid 0.5px rgba(255, 255, 255, 0.25);
    margin-bottom: 15px;
}

.inputLabel {
    color: #ffffffd9;
    font-size: 14px;
}

.amountRow {
    padding: 15px 0;

}

.amount {
    font-size: 15px;
    color: #FFF;
    padding-left: 15px;
}

.left_icon {
    color: rgba(255, 255, 255, 0.65);
    font-size: 17px;
    font-weight: bold;
    padding-right: 10px;
}

.tabList {
    display: flex;
    flex-direction: row;
    overflow-x: auto;
    white-space: nowrap;
    padding: 10px 5px;
}

.tabList::-webkit-scrollbar {
    display: none;
}

.tab_card {
    border-radius: 30px;
    width: 70px;
    color: #ffffff;
    background-color: #ffffff26;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    padding: 10px;
    margin-right: 10px;
    font-size: 14px;
}

.active_tab {
    background-image: linear-gradient(180deg, #F8D8A7 0%, #F0A853 100%);
    color: #12151A;
    border-radius: 30px;
}

.input_field>>>.van-field {
    border-radius: 10px;
    background-color: #ffffff26;
    color: #ffffffd9;
    padding: 12px 20px !important;
    margin-top: 10px;
}

.input_field>>>.van-field__control {
    color: #ffffffa6 !important;
    font-size: 12px;

}

.input_field {
    padding: 10px 0;
}

.btn_container {
    padding: 10px 80px;
}

.errorText {
    color: red;
}
</style>